import { Box, Button, Grid, StepperLines, Text } from '@approvalmax/ui/src/components';
import { FC, memo, useMemo } from 'react';

import image from './assets/edditing-approval-functionality.png';
import { nameByTypeOfGL, titleByPath } from './FirstScreen.constants';
import { messages } from './FirstScreen.messages';
import { Image } from './FirstScreen.styles';
import { FirstScreenProps } from './FirstScreen.types';

export const FirstScreen: FC<FirstScreenProps> = memo((props) => {
    const { path, typeOfGL, stepsCount, onNext, onGoToSetup } = props;

    const blocks = useMemo(
        () => [
            messages.block1,
            messages.block2,
            messages.block3,
            messages.block4,
            messages.block5({ name: nameByTypeOfGL[typeOfGL] }),
        ],
        [typeOfGL]
    );

    return (
        <Grid gap={32}>
            <StepperLines stepsCount={stepsCount} currentStep={3} />

            <Text font='headline' fontSize='small' fontWeight='regular' textAlign='center'>
                {titleByPath[path]}
            </Text>

            <Grid gap={20} gridTemplateColumns={`repeat(${blocks.length},  1fr)`}>
                {blocks.map((text, index) => (
                    <Box key={index} color='midnight30' spacing='12' radius='small'>
                        <Text font='label' fontSize='large'>
                            {text}
                        </Text>
                    </Box>
                ))}
            </Grid>

            <Image src={image} alt='' />

            <Grid gridTemplateColumns='repeat(2, max-content)' gap={40} justifyContent='end'>
                <Button variant='text' color='blue100' size='large' block onClick={onGoToSetup}>
                    {messages.goToSetup}
                </Button>

                <Button color='blue80' size='large' block onClick={onNext}>
                    {messages.next}
                </Button>
            </Grid>
        </Grid>
    );
});

FirstScreen.displayName = 'FirstScreen';
